export default __webpack_public_path__ + "static/media/mail-sent-x2.48e4bf70.png";